import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { usePlatformBrand } from "@/components/app/PlatformBrandProvider";

// Shared footer used by both the app and auth layouts. One compact
// line: copyright + legal-entity tagline on the left, inline legal
// links on the right.
//
// ExamBase is operated by Sitenet Tech Ltd (Companies House
// 12750911). The legal-entity line is required for UK Ltd
// companies trading with B2B customers — college procurement
// teams inspect it before signing.

export function Footer({ variant = "app" }: { variant?: "app" | "auth" }) {
  const brand = usePlatformBrand();
  const year = new Date().getFullYear();
  const COMPANY_INFO = {
    brand: brand.name,
    legalEntity: brand.legal_entity,
    companyNumber: brand.company_number,
    tagline: brand.tagline,
  };
  return (
    <footer
      className={cn(
        "mt-auto border-t border-border/60 bg-background/60 no-print",
        variant === "auth" && "relative",
      )}
    >
      <div className="w-full px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-2 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-0.5">
            <p>
              © {year} {COMPANY_INFO.brand} · {COMPANY_INFO.tagline}
            </p>
            <p className="text-xs text-muted-foreground">
              Operated by {COMPANY_INFO.legalEntity} · Registered in
              England &amp; Wales, company no.{" "}
              {COMPANY_INFO.companyNumber}
            </p>
            {brand.footer_text && (
              <p className="text-xs text-muted-foreground">{brand.footer_text}</p>
            )}
          </div>
          <nav
            aria-label="Legal"
            className="flex flex-wrap gap-x-4 gap-y-1"
          >
            <Link className="hover:text-foreground" to="/privacy">
              Privacy
            </Link>
            <Link className="hover:text-foreground" to="/terms">
              Terms
            </Link>
            <Link className="hover:text-foreground" to="/accessibility">
              Accessibility
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
